module.exports = __webpack_public_path__ + "static/media/Image03.bb08fcf3.png";